// src/components/itinerariosData.js
const itinerarios = [
{
    id: "puerto-madryn",
    titulo: "Puerto Madryn",
    resumen: "Ballenas, Península Valdés y Punta Tombo",
    image: "/itinerarios_files/puerto-madryn.png",
    detalle: (
    <>
        <h3 className="text-lg font-semibold mt-4 mb-1">12 OCT: Llegada a Puerto Madryn</h3>
        <p className="text-sm text-gray-700 mb-2">Traslado desde aeropuerto y alojamiento en Dazzler Puerto Madryn (Vista Ciudad, 3 noches).</p>

        <h3 className="text-lg font-semibold mt-4 mb-1">13 OCT: Península Valdés (día completo)</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 mb-2">
        <li>Visita al Área Natural Protegida Península Valdés.</li>
        <li>Opción de avistaje de ballenas francas (opcional).</li>
        <li>Visita a Caleta Valdés y observación de fauna marina.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-4 mb-1">14 OCT: Punta Tombo (opcional)</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 mb-2">
        <li>Reserva natural de pingüinos de Magallanes.</li>
        <li>Centro de interpretación + tiempo libre para almorzar.</li>
        </ul>

        <p className="text-sm mt-3"><strong>Tarifas:</strong> USD 729 single / USD 449 doble</p>
        <p className="text-sm"><strong>Aéreo:</strong> USD 350</p>
    </>
    ),
    pdf_es: "/itinerarios_files/pdf/PUERTO_MADRYN.pdf",
    pdf_en: "/itinerarios_files/pdf/PUERTO_MADRYN_EN.pdf"
},
{
    id: "el-calafate",
    titulo: "El Calafate",
    resumen: "Glaciar Perito Moreno y Estancia 25 de Mayo",
    image: "/itinerarios_files/calafate.png",
    detalle: (
    <>
        <h3 className="text-lg font-semibold mt-4 mb-1">12 OCT: Llegada a El Calafate</h3>
        <p className="text-sm text-gray-700 mb-2">Traslado y alojamiento en Design Suites El Calafate (3 noches).</p>

        <h3 className="text-lg font-semibold mt-4 mb-1">13 OCT: Glaciar Perito Moreno</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 mb-2">
        <li>Recorrido por pasarelas con múltiples balcones panorámicos.</li>
        <li>Tiempo libre para almorzar.</li>
        <li>Opcionales: Navegación Safari Náutico, Mini Trekking.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-4 mb-1">14 OCT: Estancia 25 de Mayo (opcional)</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 mb-2">
        <li>Demostración de esquila, merienda y degustación de cordero.</li>
        <li>Show folklórico y visita a huerta orgánica.</li>
        </ul>

        <p className="text-sm mt-3"><strong>Tarifas:</strong> USD 837 single / USD 599 doble</p>
        <p className="text-sm"><strong>Aéreo:</strong> consultar</p>
    </>
    ),
    pdf_es: "/itinerarios_files/pdf/EL_CALAFATE.pdf",
    pdf_en: "/itinerarios_files/pdf/EL_CALAFATE_EN.pdf"
},
{
    id: "el-calafate-ushuaia",
    titulo: "El Calafate + Ushuaia",
    resumen: "Glaciar, Estancia y Parque Nacional Tierra del Fuego",
    image: "/itinerarios_files/ushuaia-calafate1.png",
    detalle: (
    <>
        <h3 className="text-lg font-semibold mt-4 mb-1">12–14 OCT: El Calafate</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 mb-2">
        <li>Glaciar Perito Moreno (13 OCT)</li>
        <li>Estancia 25 de Mayo opcional (14 OCT)</li>
        </ul>

        <h3 className="text-lg font-semibold mt-4 mb-1">15–17 OCT: Ushuaia</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 mb-2">
        <li>City Tour por Ushuaia</li>
        <li>Parque Nacional Tierra del Fuego</li>
        <li>Tren del Fin del Mundo y navegación opcionales</li>
        </ul>

        <p className="text-sm mt-3"><strong>Tarifas:</strong> USD 1379 single / USD 937 doble</p>
        <p className="text-sm"><strong>Aéreo:</strong> USD 550</p>
    </>
    ),
    pdf_es: "/itinerarios_files/pdf/EL_CALAFATE_USHUAIA.pdf",
    pdf_en: "/itinerarios_files/pdf/EL_CALAFATE_USHUAIA_EN.pdf"
},
{
    id: "iguazu",
    titulo: "Iguazú",
    resumen: "Cataratas del Iguazú - Lado argentino y brasileño",
    image: "/itinerarios_files/iguazu.png",
    detalle: (
    <>
        <h3 className="text-lg font-semibold mt-4 mb-1">12 OCT: Cataratas lado brasileño</h3>
        <p className="text-sm text-gray-700 mb-2">Pasarelas con vista panorámica + ascensor panorámico (entrada no incluida).</p>

        <h3 className="text-lg font-semibold mt-4 mb-1">13 OCT: Cataratas lado argentino</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 mb-2">
        <li>Recorrido por pasarelas superiores, inferiores y Garganta del Diablo.</li>
        <li>Incluye uso del tren ecológico.</li>
        <li>Opcional: aventura náutica.</li>
        </ul>

        <p className="text-sm mt-3"><strong>Hotel:</strong> El Pueblito (2 noches)</p>
        <p className="text-sm"><strong>Tarifas:</strong> USD 418 single / USD 239 doble</p>
        <p className="text-sm"><strong>Aéreo:</strong> USD 220</p>
    </>
    ),
    pdf_es: "/itinerarios_files/pdf/IGUAZU.pdf",
    pdf_en: "/itinerarios_files/pdf/IGUAZU_EN.pdf"
},
{
    id: "mendoza",
    titulo: "Mendoza",
    resumen: "Ruta del vino y Alta Montaña",
    image: "/itinerarios_files/mendoza.png",
    detalle: (
    <>
        <h3 className="text-lg font-semibold mt-4 mb-1">13 OCT: Vino y oliva</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 mb-2">
        <li>Visita a bodegas y olivícolas en Luján de Cuyo y Maipú.</li>
        <li>Degustación y producción local de aceite y vino Malbec.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-4 mb-1">14 OCT: Alta Montaña</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 mb-2">
        <li>Potrerillos, Puente del Inca, mirador del Aconcagua.</li>
        <li>Almuerzo típico en Las Cuevas (no incluido).</li>
        </ul>

        <p className="text-sm mt-3"><strong>Hotel:</strong> Amerian Mendoza (3 noches)</p>
        <p className="text-sm"><strong>Tarifas:</strong> USD 689 single / USD 439 doble</p>
        <p className="text-sm"><strong>Aéreo:</strong> USD 220</p>
    </>
    ),
    pdf_es: "/itinerarios_files/pdf/MENDOZA.pdf",
    pdf_en: "/itinerarios_files/pdf/MENDOZA_EN.pdf"
},
{
    id: "salta",
    titulo: "Salta",
    resumen: "Cafayate, Quebrada de Humahuaca y City Tour",
    image: "/itinerarios_files/salta.png",
    detalle: (
    <>
        <h3 className="text-lg font-semibold mt-4 mb-1">13 OCT: City Tour</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 mb-2">
        <li>Recorrido por Catedral, Convento San Bernardo, Cerro San Bernardo.</li>
        <li>Visita a Villa San Lorenzo y mercado artesanal.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-4 mb-1">14 OCT: Cafayate</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 mb-2">
        <li>Valle de Lerma, Quebrada de las Conchas y bodegas en Cafayate.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-4 mb-1">15 OCT: Quebrada de Humahuaca</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 mb-2">
        <li>Purmamarca, Tilcara, Humahuaca, Uquía y Paleta del Pintor.</li>
        </ul>

        <p className="text-sm mt-3"><strong>Hotel:</strong> Design Suites Salta (4 noches)</p>
        <p className="text-sm"><strong>Tarifas:</strong> USD 948 single / USD 579 doble</p>
        <p className="text-sm"><strong>Aéreo:</strong> USD 220</p>
    </>
    ),
    pdf_es: "/itinerarios_files/pdf/SALTA.pdf",
    pdf_en: "/itinerarios_files/pdf/SALTA_EN.pdf"
},
];

export default itinerarios;
